export default __webpack_public_path__ + "static/media/intro-testimonial-sandals.af3fc1a5.png";